import { createQueryKeys } from "@lukemorales/query-key-factory";

import { generateCacheTag } from "../../../../utils/helpers/query/cache";
import { FederationClient } from "../../client";

import {
  GET_USER_CAN_RECOVER_PASSWORD,
  GET_USER_CAN_RECOVER_PASSWORD_V1,
  GET_USER_EMAIL_RECOVERY,
} from "./user.queries";

import type {
  IGetUserCanRecoverPasswordResponseT,
  IGetUserCanRecoverPasswordV1Variables,
  IGetUserCanRecoverPasswordVariables,
  IGetUserEmailRecoveryResponse,
  IGetUserEmailRecoveryVariables,
} from "./user.types";
import type { GQLFetcherConfigT } from "../../../utils/types";

export async function getUserEmailRecovery(variables: IGetUserEmailRecoveryVariables, config?: GQLFetcherConfigT) {
  const client = FederationClient({
    cache: "no-store",
    next: {
      tags: generateCacheTag("getUserEmailRecovery", variables.rut),
    },
  });

  const response = await client.request<IGetUserEmailRecoveryResponse, IGetUserEmailRecoveryVariables>({
    document: GET_USER_EMAIL_RECOVERY,
    variables,
    signal: config?.signal,
  });

  return response;
}

export async function getUserCanRecoverPassword(
  variables: IGetUserCanRecoverPasswordVariables,
  config?: GQLFetcherConfigT
) {
  const client = FederationClient({
    cache: "no-store",
    next: {
      tags: generateCacheTag("getUserCanRecoverPassword", variables.rut),
    },
  });

  const response = await client.request<IGetUserCanRecoverPasswordResponseT, IGetUserCanRecoverPasswordVariables>({
    document: GET_USER_CAN_RECOVER_PASSWORD,
    variables,
    signal: config?.signal,
  });

  return response;
}

export async function getUserCanRecoverPasswordV1(
  variables: IGetUserCanRecoverPasswordV1Variables,
  config?: GQLFetcherConfigT
) {
  const client = FederationClient({
    cache: "no-store",
    next: {
      tags: generateCacheTag("getUserCanRecoverPasswordV1", variables.rut),
    },
  });

  const response = await client.request<IGetUserCanRecoverPasswordResponseT, IGetUserCanRecoverPasswordV1Variables>({
    document: GET_USER_CAN_RECOVER_PASSWORD_V1,
    variables,
    signal: config?.signal,
  });

  return response;
}

export const userQuery = createQueryKeys("user", {
  getUserEmailRecovery: (variables: IGetUserEmailRecoveryVariables) => ({
    queryKey: ["getUserEmailRecovery", variables],
    queryFn: ({ signal }) => getUserEmailRecovery(variables, { signal }),
  }),
  getUserCanRecoverPassword: (variables: IGetUserCanRecoverPasswordVariables) => ({
    queryKey: ["getUserCanRecoverPassword", variables],
    queryFn: ({ signal }) => getUserCanRecoverPassword(variables, { signal }),
  }),
  getUserCanRecoverPasswordV1: (variables: IGetUserCanRecoverPasswordV1Variables) => ({
    queryKey: ["getUserCanRecoverPasswordV1", variables],
    queryFn: ({ signal }) => getUserCanRecoverPasswordV1(variables, { signal }),
  }),
});
